/**
 * The SCT summary as its own page under Costing, beside OPA / SCT — Max, 2026-08-30.
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import SctSummary from './32_SctSummary';
import ModuleHelp from './ModuleHelp';
import { BACKEND_URL } from './backendConfig';
import './PricingCalculator.css';
import './SPHub.css';

/* THE GUIDE (Max 01/11: every module has one). The Export and Import buttons carry data-tour in 32_SctSummary.jsx;
   the other controls have class names of their own. */
const TOUR = [
  { selector: '.sct-sum .opa-search', title: 'tourSctSummary.searchT', body: 'tourSctSummary.searchB' },
  { selector: '.sct-sum .opa-bar select', title: 'tourSctSummary.seasonT', body: 'tourSctSummary.seasonB' },
  { selector: '[data-tour="sct-export"]', title: 'tourSctSummary.exportT', body: 'tourSctSummary.exportB' },
  { selector: '[data-tour="sct-import"]', title: 'tourSctSummary.importT', body: 'tourSctSummary.importB' },
  { selector: '.sct-scroll table.sct-table', title: 'tourSctSummary.tableT', body: 'tourSctSummary.tableB' },
];

export default function SctSummaryPage() {
  const { t } = useTranslation();
  /* SctSummary loads its own rows and does not report back; its toolbar is drawn from the first render. */
  const [ready, setReady] = useState(false);
  useEffect(() => { const id = window.setTimeout(() => setReady(true), 900); return () => window.clearTimeout(id); }, []);
  return (
    <div className="sp-page">
      <Header />
      <div className="sp-main">
        <div className="mh-titlerow">
          <div className="sp-title">
            <h2>{t('nav.sctSummary')}</h2>
            <p>{t('xSct.pageSub')}</p>
          </div>
          <ModuleHelp steps={TOUR} tourKey="sctSummary" ready={ready} />
        </div>
        <SctSummary apiBase={`${BACKEND_URL}/api`} />
      </div>
    </div>
  );
}
